export interface Contract {
  id: number;
  contractId: number;
  contractNumber: string;
  contractGroupTypeId: number;
  contractGroupTypeName: string;
  contractProgramShortName: string;
  aircraftId: number;
  contractProgramId: number;
  contractProgramName: string;
  lastModUserId: number;
  lastModDateUtc: string;
  contractCaptureTypeId: number;
  contractCaptureTypeName: string;
  effectiveDate: string;
  expiryDate: string;
  anniversaryDay: number;
  anniversaryMonth: number;
  createDateUtc: string;
  createUserId: number;
  isDeleted: boolean;
  startHours: number;
  startLandings: number;
  sapcontractNumber?: string;
  previousContractSurplusRollover?: number;
  serialNumber: string;
  deliveryDate: string;
  sysAircraftModelId: number;
  aircraftModelName: string;
  sysRateEscalationTypeId: number;
  rateEscalationName: string;
  warrantyExpiryDate?: string;
  warrantyExpiryHours?: number;
  leftEngineWarrantyExpiryDate?: string;
  leftEngineWarrantyExpiryHours?: number;
  rightEngineWarrantyExpiryDate?: string;
  rightEngineWarrantyExpiryHours?: number;
  apuwarrantyExpiryDate?: string;
  apuwarrantyExpiryHours?: number;
  cabinWarrantyExpiryHours?: number;
  cabinWarrantyExpiryDate?: string;
  accountManagerName: string;
  estimatedValue: number;
  announcedValue: number;
  contractStatusName: string;
  contractStatusId: number;
  accountManagerId: number;
  aircraftMakeName?: string;
  lastFlightCardEndDate?: string;
  clientReportTypeIds?: number[];
  securityDeposit?: number;
  rateEscalationTypeId?: number;
  oldPk: string;
  contractGroupingForAnalyticId: number;
  isTransferable: boolean;
  comment: string;
  sysAircraftMakeId: number;
  clientReportTypeIdString: number;
  securityRoleId: number;
  accountReceivableNumber: number;
  formsToFill: number;
  contractBillingEntityName: string;
  lastTransferDate?: Date;
  contractReceivedDate: string;
  contractSignedDate: string;
  hasMinHourSolutionOption: boolean;
  billingBasedOn?: number;
  tailNumber: string;
  hasFree: boolean;
  hasConcession: boolean;
  wasAmended: boolean;
  isDealerContract: boolean;
  isPreDelivery: boolean;
  contractualAnnualMinHours: number;
  hasAcknowledgementOfAssignment: boolean;
  additionalInvoiceAmount: number;
  automatedBillingAmount: number;
  costAmount: number;
  pendingCostAmount: number;
  surplusDeficitInvoicedAmount: number;
  masterBillToId: number;
  contractualStandardMinHours: number;
  rsmEntityId: number;
  contractTransactionEndDate?: string;
  inWarrantyFloorRate?: number;
  afterWarrantyFloorRate?: number;
  overageCapRate?: number;
  lastReconcileBillingConsoleItemId?: number;
  isReconciled?: boolean;
  products?: string;
  statusChangeCreateDateUtc?: string;
  sysContractStatusChangeReasonId?: number;
  statusChangeComment?: string;
  baseLocationCountry?: string;
  baseLocationState?: string;
  newContractNumber?: string;
  newSignatureDate?: string;
  ownerAccountName?: string;
  operatorAccountName?: string;
  originalStatusID?: number;
  newContractStatus?: string;

  // Manually Generated Fields
  aircraftName?: string;
  isExpired?: boolean;
  displayEffectiveDate?: string;
  displayExpiryDate?: string;
  displayContractTransactionEndDate?: string;
  displayLastTransferDate?: string;
  displayAnniversaryMonth?: string;
  nextFlightCardEndDate?: string;
  nextFlightCardEndDateSort?: string;
  billingBasedOnName?: string;
  surplusOrDeficit?: number;
  displayStatusChangeCreateDateUTC?: string;
  aging?: number;
  sysContractStatusChangeReasonName?: string;
  reEnrollmentPeriod?: string;
  aircraftAge?: number;
  originalStatusName?: string;
  revenue?: number;
}

export const initialContract: Contract = {
  contractId: 0,
  contractNumber: '',
  contractGroupTypeId: 0,
  contractGroupTypeName: '',
  aircraftId: 0,
  contractProgramId: 0,
  contractProgramName: '',
  createUserId: 0,
  lastModUserId: 0,
  contractCaptureTypeId: 0,
  contractCaptureTypeName: '',
  effectiveDate: '',
  expiryDate: '',
  anniversaryDay: 0,
  anniversaryMonth: 0,
  createDateUtc: '',
  isDeleted: false,
  lastModDateUtc: '',
  startHours: 0,
  startLandings: 0,
  serialNumber: '',
  deliveryDate: '',
  contractProgramShortName: '',
  sysAircraftModelId: 0,
  aircraftModelName: '',
  sysRateEscalationTypeId: 0,
  rateEscalationName: '',
  id: 0,
  warrantyExpiryDate: '',
  warrantyExpiryHours: 0,
  leftEngineWarrantyExpiryDate: '',
  leftEngineWarrantyExpiryHours: 0,
  rightEngineWarrantyExpiryDate: '',
  rightEngineWarrantyExpiryHours: 0,
  apuwarrantyExpiryDate: '',
  apuwarrantyExpiryHours: 0,
  cabinWarrantyExpiryDate: '',
  cabinWarrantyExpiryHours: 0,
  accountManagerName: '',
  estimatedValue: 0,
  announcedValue: 0,
  contractStatusName: '',
  contractStatusId: 0,
  accountManagerId: 0,
  clientReportTypeIds: [],
  securityDeposit: 0,
  rateEscalationTypeId: 0,
  oldPk: '',
  contractGroupingForAnalyticId: 0,
  isTransferable: false,
  comment: '',
  sysAircraftMakeId: 0,
  clientReportTypeIdString: 0,
  securityRoleId: 0,
  accountReceivableNumber: 0,
  formsToFill: 0,
  contractBillingEntityName: '',
  lastTransferDate: undefined,
  contractReceivedDate: '',
  contractSignedDate: '',
  hasMinHourSolutionOption: false,
  billingBasedOn: undefined,
  tailNumber: '',
  hasFree: false,
  hasConcession: false,
  wasAmended: false,
  isDealerContract: false,
  isPreDelivery: false,
  contractualAnnualMinHours: 0,
  hasAcknowledgementOfAssignment: false,
  additionalInvoiceAmount: 0,
  automatedBillingAmount: 0,
  costAmount: 0,
  pendingCostAmount: 0,
  surplusOrDeficit: 0,
  surplusDeficitInvoicedAmount: 0,
  masterBillToId: 0,
  contractualStandardMinHours: 0,
  rsmEntityId: 0,
  contractTransactionEndDate: '',
  products: '',
};
